// metronic_8 entry point — bridges to the base tier's hiveMind with metronic_8-specific app.
const hiveMind = require('../../../../core/themes/base/scripts/hiveMind');

// Inject metronic_8's behaviour adapters. The local module starts from
// bootstrap5's bootstrap-flavoured baseline (modal/collapse/toast/popover
// + the Step 2c/5c additions: blockUI/drawer/submenu/breakpoint) and
// overrides six hooks with KT-wrapping adapters (submenu/drawer/blockUI/
// breakpoint/imageInput/passwordMeter) so behaviour stays identical to
// today's m8 pages once Step 5e routes base consumers through
// hm.behaviors.
hiveMind.behaviors = require('./behaviors');

// Inject metronic_8-specific app (KTComponents init + KTApp page loading)
hiveMind.app = require('./app');

// Inject metronic_8 controller loader so webpack builds the correct file context
// for this theme's controllers view directory (relative require here = metronic_8/views/controllers/)
hiveMind.requireController = function (controllerPath) {
    try {
        return require('../views/controllers/' + controllerPath);
    } catch (e) {
        return false;
    }
};

// Inject metronic_8 component loader. Resolves component JS leaf-first: this
// theme's own components first, then the app-level neutral tier (theme-agnostic,
// app-specific components shared by every leaf theme). Each require prefix is a
// separate webpack file context (metronic_8/components/ and neutral/components/).
// base components are the final fallback inside hiveMind.newComponent() (step 2).
hiveMind.requireComponent = function (componentType) {
    // 1. metronic_8's own components.
    try {
        return require('../components/' + componentType + '/' + componentType);
    } catch (e) {}
    // 2. neutral tier (app/themes/neutral/components).
    try {
        return require('../../neutral/components/' + componentType + '/' + componentType);
    } catch (e) {}
    return false;
};

// Expose hiveMind on window as a debug surface (NOT a public API). Lets
// developers and support reach the framework from the browser console
// (e.g. `zonait.hm.app.controller`, `zonait.hm.behaviors.collapse.stateClass('shown')`).
// Application code MUST NOT use this entry point — components receive `hm`
// via hiveMind.adopt(), and ad-hoc reaches into window.zonait.hm break that
// injection contract. Carries no secrets by design: anything sensitive on
// the hiveMind subtree is a bug to fix at the source, not by hiding the
// global.
window.zonait = window.zonait || {};
window.zonait.hm = hiveMind;

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => { hiveMind.main(); });
} else {
    hiveMind.main();
}
